export default __webpack_public_path__ + "3cf7fde977047d0d46f334ad93044820.svg";